import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function Sidebar({ systemStatus, cycleCount, lastUpdate, indicatorSignals }) {
  const location = useLocation();
  const path = location.pathname;

  const renderIndicatorBadge = () => {
    if (!indicatorSignals) return null;
    const { tf5m, tf3m } = indicatorSignals;
    return (
      <div className="sidebar-signal-group" title="Intraday buy setup signals">
        <span className={`sidebar-signal-chip ${tf5m?.state === 'on' ? 'on' : 'off'}`}>5m</span>
        <span className={`sidebar-signal-chip ${tf3m?.state === 'on' ? 'on' : 'off'}`}>3m</span>
      </div>
    );
  };

  return (
    <nav className="sidebar">
      <div className="sidebar-brand">
        <div className="sidebar-logo">OS</div>
        <h1>OptionSelling</h1>
      </div>

      <div className="sidebar-nav">
        <div className="sidebar-section-label">Overview</div>
        <NavLink to="/" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} end>
          <span className="sidebar-icon">📊</span>
          <span>Dashboard</span>
        </NavLink>
        <NavLink to="/indicators" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">📈</span>
          <span>Indicators</span>
          {renderIndicatorBadge()}
        </NavLink>

        <div className="sidebar-section-label">Trading</div>
        <NavLink to="/strategies" className={({ isActive }) => {
          const isStrategyPage = path.startsWith('/strategies') || path === '/manual-trade' || path === '/rolling-strangle';
          return `sidebar-link ${isActive || isStrategyPage ? 'active' : ''}`;
        }}>
          <span className="sidebar-icon">⚡</span>
          <span>Strategies</span>
        </NavLink>

        <div className="sidebar-section-label">Analysis</div>
        <NavLink to="/positions" className={({ isActive }) => {
          return `sidebar-link ${isActive || path === '/premium-chart' || path === '/option-chain' ? 'active' : ''}`;
        }}>
          <span className="sidebar-icon">📋</span>
          <span>Positions</span>
        </NavLink>

        <div className="sidebar-section-label">History</div>
        <NavLink to="/trade-history" className={({ isActive }) => {
          return `sidebar-link ${isActive || path === '/backtest' ? 'active' : ''}`;
        }}>
          <span className="sidebar-icon">📅</span>
          <span>History</span>
        </NavLink>

        <div className="sidebar-divider" />
        <NavLink to="/settings" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="sidebar-icon">⚙️</span>
          <span>Settings</span>
        </NavLink>
      </div>

      <div className="sidebar-footer">
        <div className="sidebar-status">
          <span className={`status-dot ${systemStatus?.market_hours ? 'live' : 'closed'}`} />
          <span>{systemStatus?.market_hours ? 'Market Live' : 'Market Closed'}</span>
        </div>
        <div className="sidebar-meta">
          <span>Cycle #{cycleCount}</span>
          <span className="sidebar-update">{lastUpdate || '—'}</span>
        </div>
      </div>
    </nav>
  );
}
